<template>
  <div>
    <c-checkbox v-if="node.enabledPath" v-model="enabledData" />
    <a href="#" @click.prevent="toggleOrClick"
      :class="{ 'item-link': true, 'bordered': isSelected }">
      <span class="label-block">
        {{ node.label }}
        <b-icon
          v-if="hasError"
          type="is-danger"
          icon="exclamation-circle"
          size="is-small"
        />
      </span>
      <span class="icon-block" v-if="hasChildren">
        <b-icon icon="angle-down" v-if="expanded" />
        <b-icon icon="angle-left" v-if="!expanded" />
      </span>
    </a>
    <ul v-if="hasChildren && expanded">
      <li v-for="node in node.children" :key="node.label">
        <nav-item
          v-model="value"
          :node="node"
          :errors="errors"
          :errorsPaths="errorsPaths"
          :path="[...path, node.path]"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import objectPath from 'object-path'
import CCheckbox from '@/lib/components/Checkbox'

export default {
  name: 'nav-item',
  props: ['value', 'node', 'errors', 'path', 'errorsPaths'],
  data() {
    return {
      expanded: this.isExpanded(),
    }
  },
  components: {
    CCheckbox,
  },
  computed: {
    isSelected() {
      return this.isExpanded()
    },
    enabledData: {
      get() {
        return objectPath.get(this.value, this.node.enabledPath)
      },
      set(value) {
        objectPath.set(this.value, this.node.enabledPath, value)
      },
    },
    hasChildren() {
      return this.node.children && this.node.children.length > 0
    },
    hasFields() {
      return this.node.enabledPath || (this.node.fields && this.node.fields.length > 0)
    },
    hasError() {
      return this.hasErrorInNode(this.node)
    },
  },
  methods: {
    hasErrorInNode(node) {
      if (node.children && node.children.length > 0) {
        return node.children.some(node => this.hasErrorInNode(node))
      }

      if (node.fields && node.fields.length > 0) {
        return node.fields.some(field => this.hasErrorInField(field))
      }

      return false
    },
    hasErrorInField(field) {
      if (field.fields && field.fields.length > 0) {
        return field.fields.some(field => this.hasErrorInField(field))
      }

      return this.errorsPaths.some(path => field.path === path)
    },
    toggleOrClick() {
      if (this.hasChildren) {
        this.expanded = !this.expanded
      } else {
        if (this.hasFields) {
          const hash = this.path.join('/')
          this.$router.push('#' + hash)
        }
      }
    },
    isExpanded() {
      const hash = (this.$route.hash.slice(1) || 'general').split('/')
      return this.path.every((item, i) => item === hash[i])
    },
  },
}
</script>

<style scoped>
.item-link {
  padding: 0.5em 0;
  margin-left: 30px;
  margin-right: 5px;
}
.bordered {
  border: 1px solid black;
  border-radius: 4px;
}
.label-block {
  padding-left: 5px;
}
.icon-block {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/Form/NavItem.vue